import React, { Fragment, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import dayjs from "dayjs";
import Spinner from "../plugins/Spinner";
import useAPI from "../../hooks/useAPI";
import { Chart, registerables } from "chart.js";
import {sendToast} from "../plugins/toastAll";
import Header from "../layout/Header";
import {
  BsCheck,
  BsCheckAll,
  BsX,
  BsSearch
} from 'react-icons/bs';

import {
  FaAngleLeft,
  FaListOl,
  FaRegClock,
  FaComment,
  FaCalendarCheck,
  FaTimesCircle,
  FaInfoCircle,
  FaLongArrowAltRight,
  FaPhoneAlt
} from 'react-icons/fa';

import { BiSolidDownArrowCircle, BiSolidHelpCircle } from "react-icons/bi";
import { PiUsersThreeFill } from "react-icons/pi";
import { IoMdSend } from "react-icons/io";
import { Bar } from "react-chartjs-2";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { Toaster } from "react-hot-toast";

Chart.register(...registerables);

export const erroresWhatsappCloud = {
  0: "Error de autenticación: el token es inválido o expiró.",
  2: "Servicio temporalmente no disponible por mantenimiento o sobrecarga.",
  3: "Método de API no permitido o faltan permisos.",
  4: "Se hizo demasiadas llamadas a la API en poco tiempo. Espera antes de reintentar.",
  10: "Permiso denegado: la app no tiene los permisos necesarios.",
  33: "Valor de parámetro no válido (p. ej. número o plantilla).",
  100: "Parámetro inválido: revisa los valores enviados.",
  130429: "No se pudo enviar: límite de mensajes por segundo alcanzado.",
  130472: "No se pudo enviar: el número de teléfono del usuario forma parte de un experimento.",
  131000: "No se pudo enviar: error interno desconocido en el servidor.",
  131008: "No se pudo enviar: falta un parámetro obligatorio.",
  131009: "No se pudo enviar: valor de parámetro inválido o número no es contacto de WhatsApp.",
  131016: "No se pudo enviar: servicio de WhatsApp temporalmente no disponible.",
  131021: "No se pudo enviar: el remitente y destinatario son el mismo.",
  131026: "No se pudo entregar el mensaje: posibles causas de versión desactualizada, no aceptación de términos o número no registrado.",
  131031: "No se pudo enviar: la cuenta de WhatsApp Business está bloqueada o restringida.",
  131037: "No se pudo enviar: falta aprobación del nombre para mostrar.",
  131042: "No se pudo enviar: hay un problema con tu método de pago o elegibilidad.",
  131045: "No se pudo enviar: certificado incorrecto o número no registrado correctamente.",
  131047: "No se pudo enviar: ya pasaron 24 h desde el último mensaje del usuario; usa una plantilla.",
  131048: "No se pudo enviar: límite por spam alcanzado.",
  131049: "No se entregó el mensaje para mantener la calidad del ecosistema.",
  131051: "No se envió: tipo de mensaje no soportado.",
  131052: "No se pudo descargar el archivo multimedia.",
  131053: "No se pudo subir el archivo multimedia.",
  131057: "No se pudo enviar: la cuenta está en modo de mantenimiento.",
  132000: "No se pudo enviar: la cantidad de parámetros de plantilla no coincide.",
  132001: "No se envió: la plantilla no existe o no está aprobada.",
  132005: "No se envió: el texto de la plantilla es demasiado largo.",
  132007: "No se envió: la plantilla viola políticas de formato.",
  132012: "No se envió: formato de parámetros de plantilla incorrecto.",
  132015: "No se envió: la plantilla fue pausada por baja calidad.",
  132016: "No se envió: la plantilla fue deshabilitada permanentemente por baja calidad.",
  132068: "No se pudo enviar: el flujo está bloqueado.",
  132069: "No se pudo enviar: el flujo está limitado (throttled).",
  133000: "No se completó la cancelación de registro anterior.",
  133004: "No se pudo enviar: el servidor de WhatsApp está temporalmente no disponible.",
  133005: "No se pudo verificar PIN: la verificación de dos pasos falló.",
  133006: "No se pudo enviar: se requiere re-verificación del número de teléfono.",
  133008: "No se pudo enviar: demasiados intentos de PIN de verificación.",
  133009: "No se pudo enviar: PIN ingresado demasiado rápido varias veces.",
  133010: "No se pudo enviar: el número de teléfono no está registrado en WhatsApp Business.",
  133015: "No se pudo registrar: espera unos minutos antes de reintentar.",
  135000: "Error genérico: revisa los parámetros o contacta soporte.",
};

const CampaignReport = () => {
  const [loading, setLoading] = useState(false);
  const [navegationView, setNavegationView] = useState("all");
  const [campaignData, setCampaignData] = useState({
    nameCampaign: "",
    sendingDateCampaign: "",
    creationDateCampaign: "",
    nameListCampaign: "",
    numberUsers: 0,
    notMessages: 0,
    dataBar: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
        },
      ],
    },
    dataSent: {
      num: 0,
      percentage: 0,
      percentageVol: 0 
    },
    dataDelivered: {
      num: 0,
      percentage: 0,
      percentageVol: 0 
    },
    dataRead: {
      num: 0,
      percentage: 0,
      percentageVol: 0 
    },
    dataFailed: {
      num: 0,
      percentage: 0,
      percentageVol: 0 
    }            
  });
  const [filtCampaign, setFiltCampaign] = useState([]);
  const [filtAll, setFiltAll] = useState([]);
  
  const [search, setSearch] = useState("");
  const [MenssageTranslated, setMenssageTranslated] = useState("");
  
  const { urlAPI_1, fetchWithAuth } = useAPI();
  const [validation, setValidation] = useState(false);

  const token = localStorage.getItem("USER_TOKEN");
  const { id } = useParams();

  useEffect(() => {
    getCampaignSelected(id);
  }, []);

  const getCampaignSelected = async (id) => {
    try {
      setLoading(true);
      const url = urlAPI_1 + "getDataReport/" + id;
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      if (result.type !== "success") {
        setLoading(false);
        sendToast(result)
      }

      const data = result.data;
      console.log("data: ", data);
      const all_messages = [
        ...data.contacts_sent,
        ...data.contacts_delivered,
        ...data.contacts_read,
        ...data.contacts_error,
      ];
      setFiltCampaign(all_messages);
      setFiltAll(all_messages);
    
      const campaign_data = {
        nameCampaign: data.campaign.description,
        nameListCampaign: data.listName,
        numberUsers: data.campaign.results.total,
        creationDateCampaign: dayjs(data.campaign.created)
          .locale("es")
          .format("DD MMMM YYYY"),
        sendingDateCampaign: dayjs(data.campaign.dateProgram)
          .locale("es")
          .format("DD MMMM YYYY"),
        notMessages: all_messages.length,
        dataBar: {
          labels: ["Enviados", "Entregados", "Leídos", "Fallidos"],
          datasets: [
            {
              label: "Información de la campaña",
              data: [
                data.contacts_sent.length,
                data.contacts_delivered.length,
                data.contacts_read.length,
                data.contacts_error.length,
              ],
              backgroundColor: ["#667580", "#58b658", "#57bedd", "#f81a33"],
            },
          ],
        }
      };


      let allMessages = data.campaign.results.total;

      const computeAndSetPercentageData = (dataKey, dataValue) => {
        let percentage = 0;
        if(allMessages){        
          percentage = (
            (dataValue.length * 100) /
            allMessages
          ).toFixed(2);
        }
        const percentage_vol = (472 - 472 * (percentage / 100)).toFixed(0);
        campaign_data[dataKey] = {
          num: dataValue.length,
          percentage: percentage,
          percentageVol: percentage_vol,
        };
      };

      computeAndSetPercentageData("dataSent", data.contacts_sent);
      computeAndSetPercentageData("dataDelivered", data.contacts_delivered);
      computeAndSetPercentageData("dataRead", data.contacts_read);
      computeAndSetPercentageData("dataFailed", data.contacts_error);
      console.log(campaign_data);
      setCampaignData(() => {return campaign_data});
      setLoading(false);

    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  const onFilterAll = () => {
    setFiltCampaign(filtAll);
    setNavegationView("all");
    setCampaignData(() => {return { ...campaignData, notMessages: filtAll.length }});
  };

  const onFilter = (status) => {
    const resultFilter = filtAll.filter((element) => element.status === status);
    console.log("resultFilter: ", resultFilter);
    
    setFiltCampaign(resultFilter);
    setNavegationView(status);
    setCampaignData(() => {return { ...campaignData,  notMessages: resultFilter.length }});
    if (resultFilter.length <= 0) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const navigate = useNavigate();

  const searchQuery = (searchTerm) => {
    const searchResults = filtAll.filter((element) => {
      if (element.sendTo.toString().toLowerCase().includes(searchTerm.toLowerCase()) ) {
        return element;
      }
    });
    setFiltCampaign(searchResults);
    if (searchResults.length <= 0) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const translate = (message) => {
    const error = message;
    if (error) {
      const codigo = error?.code;
      const fallback = error?.error_data?.details || "No fue posible enviar el mensaje.";
      // console.info("💬 Mensaje de error: ", fallback);
  
      if (codigo && erroresWhatsappCloud[codigo]) {
        setMenssageTranslated(erroresWhatsappCloud[codigo]);
      } else {
        console.warn("⚠️ Código de error no mapeado:", codigo, fallback);
        setMenssageTranslated(fallback);
      }
    }
  }

  return (
    <Fragment>
      {loading && (
        <div className="content-spinner">
          <Spinner />
        </div>
      )}
      <div className="row mx-auto container-fluid p-0 justify-content-between border-top-0 border-right-0 border-left-0 border-secondary mb-3">
        <div style={{ height: "45px", lineHeight: "95px" }}>
          <button
            type="button"
            className="btn btn-left col-1-sm-3 my-auto position-absolute d-flex"
            onClick={() => {
              navigate(`/home/campaign`);
              setNavegationView("all");
            }}
          >
            <FaAngleLeft /> Campañas
          </button>
        </div>

        <Header />
      </div>
      <header className="filter-report d-flex align-items-center justify-content-between">
        <div className="d-flex">
          <input type="hidden" id="idStore" size="40" value="1399" name="store" />
          <button className={`btn-filter btn btn-link btn-link-all d-flex ${navegationView === "all" ? "active" : ""}`} onClick={onFilterAll}>
            <FaListOl className="mr-1" /> Todos
          </button>
          <a className={`btn-filter btn btn-link d-flex ${navegationView === "sent" ? "active" : ""}`} onClick={() => onFilter("sent")}>
            <BsCheck className="mr-1" style={{ fontSize: "1.35rem", color: "#667580" }} /> Enviados
          </a>
          <a className={`btn-filter btn btn-link d-flex ${navegationView === "delivered" ? "active" : ""}`} onClick={() => onFilter("delivered")}>
            <BsCheckAll className="mr-1" style={{ fontSize: "1.35rem", color: "#58b658" }} /> Entregados
          </a>
          <a className={`btn-filter btn btn-link d-flex ${navegationView === "read" ? "active" : ""}`} onClick={() => onFilter("read")}>
            <BsCheckAll className="mr-1" style={{ fontSize: "1.35rem", color: "#57bedd" }} /> Leidos
          </a>
          <a className={`btn-filter btn btn-link d-flex ${navegationView === "error" ? "active" : ""}`} onClick={() => onFilter("error")}>
            <BsX className="mr-1" style={{ fontSize: "1.35rem", color: "#f81a33" }} /> Fallidos
          </a>
        </div>

        <div style={{ float: "right" }}>
          <form className="form-inline">
            <div className="su-control mt-1">
              <input
                className="form-control"
                type="text"
                placeholder="Búsqueda"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchQuery(e.target.value);
                }}
              />
              <button
                className="btn btn-info"
                type="button"
                id="buttonSearchProductBack"
                style={{ height: "34px" }}
              >
                <BsSearch />
              </button>
            </div>
          </form>
        </div>
      </header>

      <div 
        className="container-fluid mt-3 px-0"
        style={
          campaignData.notMessages === 0
            ? { height: "230px", overflow: "auto" }
            : campaignData.notMessages <= 4
            ? { height: "310px", overflow: "auto" }
            : { height: "460px", overflow: "auto" }
        }
      >
        <table className="table table-striped campaigns-report">
          <thead style={{ position: "sticky", top: "-1px", zIndex: "99" }}>
            <tr>
              <th>Enviado a</th>
              <th>Estado</th>
              <th>Fecha de creación</th>
              <th>Fecha de envío</th>
            </tr>
          </thead>
          <tbody>
            {filtCampaign.length ? (filtCampaign.map((campaign, k) => (
              <tr key={k}>
                <td className="d-flex align-items-center justify-content-center">
                  <div>{campaign.name.length > 15 ? campaign.name.substr(0, 12) + "..." : campaign.name}</div>
                  <div className="ml-3"><FaLongArrowAltRight /></div>
                  <div className="pointer ml-1" data-tooltip-id="my-tooltip" data-tooltip-content={campaign.sendTo}><FaPhoneAlt /></div>
                </td>
                <td className="status-campaign">
                  {
                    <p className="d-flex align-items-center justify-content-center">
                      <a href="javascript:;" className={campaign.status === "sent" ? "gray" : campaign.status === "delivered" ? "green" : campaign.status === "read" ? "blue" : "red"}>
                        {
                          campaign.status === "sent" ? "Enviado"
                            : campaign.status === "delivered" ? "Entregado"
                            : campaign.status === "read" ? "Leido"
                            : "Fallido"
                        }
                      </a>
                      {(campaign.status !== "sent" && campaign.status !== "delivered" && campaign.status !== "read" && campaign.metaErrors?.[0]) && 
                        <div className="position-relative">
                          <FaInfoCircle 
                            onMouseEnter={() => {translate(campaign.metaErrors?.[0])}}
                            className="ml-1 pointer" 
                            id="error-send"
                            style={{ color: "#08e3ff", fontSize: "18px" }} 
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={MenssageTranslated}
                          />
                        </div>
                      }
                    </p>
                  }
                </td>
                <td>
                  {dayjs(campaign.creationdate)
                    .locale("es")
                    .format("DD MMMM YYYY")}
                </td>
                <td>
                  {dayjs(campaign.sendingdate)
                    .locale("es")
                    .format("DD MMMM YYYY")}
                </td>
              </tr>
            ))
            ) : ("")}
          </tbody>
        </table>
        {validation && (
          <h1 className="text-center mt-3">Sin registros</h1>
        )}
      </div>

      <section className="module-create-user mt-4" style={{ width: "100%" }}>
        <header className="message text-center">
          <div id="tittleFormProduct">
            <h1>Progreso de la campaña</h1>
          </div>
        </header>

        <form className="Form-create-new-template abstract">
          <div className="mb-3 px-3">
            <h1>{campaignData.nameCampaign}</h1>
            <div className="v-card-text pt-0 pb-3 px-3">
              <div className="row d-flex">
                <div className="list-result mb-4 col-md-5 col-12">
                  <div className="list-item">
                    <div className="list-item__action">
                      <BiSolidHelpCircle className="icons-report" />
                    </div>
                    <div className="list-item__content">
                      <div className="list-item__title">Enviada</div>
                      <div className="list-item__subtitle">
                        Estado de la campaña
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="list-item__action">
                      <PiUsersThreeFill className="icons-report" />
                    </div>
                    <div className="list-item__content">
                      <div className="list-item__title">
                        {campaignData.numberUsers}
                      </div>
                      <div className="list-item__subtitle">
                        {campaignData.nameListCampaign}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="list-item__action">
                      <FaComment className="icons-report" />
                    </div>
                    <div className="list-item__content">
                      <div className="list-item__title">
                        Mensajes enviados
                      </div>
                      <div className="list-item__subtitle">
                        {campaignData.dataSent.num +
                          campaignData.dataDelivered.num +
                          campaignData.dataRead.num}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="list-item__action">
                      <FaCalendarCheck className="icons-report" />
                    </div>
                    <div className="list-item__content">
                      <div className="list-item__title">
                        {campaignData.creationDateCampaign}
                      </div>
                      <div className="list-item__subtitle">
                        Fecha de creación
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="list-item__action">
                      <IoMdSend className="icons-report" />
                    </div>
                    <div className="list-item__content">
                      <div className="list-item__title">
                        {campaignData.sendingDateCampaign}
                      </div>
                      <div className="list-item__subtitle">Fecha de envío</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-7 col-12">
                  <div className="canvas-bar">
                    <div>
                      <Bar data={campaignData.dataBar} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>

      <section style={{ display: "flex", gap: "30px" }} className="mb-3">
        <div
          data-v-09835e9f=""
          style={{ width: "33.333333%" }}
          className=" module-report-graphics box px-0"
        >
          <header className="message text-center">
            <div id="tittleFormProduct">
              <h1>Enviados</h1>
            </div>
          </header>
          <div
            data-v-09835e9f=""
            className="fill-height v-card v-sheet theme--light kbWhite"
          >
            <div className="v-card__text py-4 m-carrier">
              <div className="row ma-0 justify-content-center">
                <div className="text-center col col-12"></div>
                <div className="skill">
                  <div className="outer">
                    <div className="inner">
                      <p>{campaignData.dataSent.num}</p>
                      <div id="#por">
                        {campaignData.dataSent.percentage}%
                      </div>
                    </div>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="160px"
                    height="160px"
                  >
                    <Circle
                      cx="80"
                      cy="80"
                      r="70"
                      stroke-linecap="round"
                      style={{
                        strokeDashoffset:
                          campaignData.dataSent.percentageVol,
                      }}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-v-09835e9f=""
          style={{ width: "33.333333%" }}
          className=" module-report-graphics box px-0"
        >
          <header className="message text-center">
            <div id="tittleFormProduct">
              <h1>Entregados</h1>
            </div>
          </header>
          <div
            data-v-09835e9f=""
            className="fill-height v-card v-sheet theme--light kbWhite"
          >
            <div className="v-card__text py-4 m-carrier">
              <div className="row ma-0 justify-content-center">
                <div className="text-center col col-12"></div>
                <div className="skill">
                  <div className="outer">
                    <div className="inner">
                      <p>{campaignData.dataDelivered.num}</p>
                      <div id="#por">
                        {campaignData.dataDelivered.percentage}%
                      </div>
                    </div>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="160px"
                    height="160px"
                  >
                    <Circle1
                      cx="80"
                      cy="80"
                      r="70"
                      stroke-linecap="round"
                      style={{
                        strokeDashoffset:
                          campaignData.dataDelivered.percentageVol,
                      }}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-v-09835e9f=""
          style={{ width: "33.333333%" }}
          className=" module-report-graphics box px-0"
        >
          <header className="message text-center">
            <div id="tittleFormProduct">
              <h1>Leídos</h1>
            </div>
          </header>
          <div
            data-v-09835e9f=""
            className="fill-height v-card v-sheet theme--light kbWhite"
          >
            <div className="v-card__text py-4 m-send">
              <div className="row ma-0 justify-content-center">
                <div className="text-center col col-12"></div>
                <div className="skill">
                  <div className="outer">
                    <div className="inner">
                      <p>{campaignData.dataRead.num}</p>
                      <div id="#por">{campaignData.dataRead.percentage}%</div>
                    </div>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="160px"
                    height="160px"
                  >
                    <Circle2
                      cx="80"
                      cy="80"
                      r="70"
                      stroke-linecap="round"
                      style={{
                        strokeDashoffset:
                          campaignData.dataRead.percentageVol,
                      }}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-v-09835e9f=""
          style={{ width: "33.333333%" }}
          className=" module-report-graphics box px-0"
        >
          <header className="message text-center">
            <div id="tittleFormProduct">
              <h1>Fallidos</h1>
            </div>
          </header>
          <div
            data-v-09835e9f=""
            className="fill-height v-card v-sheet theme--light kbWhite"
          >
            <div className="v-card__text py-4 m-send">
              <div className="row ma-0 justify-content-center">
                <div className="text-center col col-12"></div>
                <div className="skill">
                  <div className="outer">
                    <div className="inner">
                      <p>{campaignData.dataFailed.num}</p>
                      <div id="#por">
                        {campaignData.dataFailed.percentage}%
                      </div>
                    </div>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="160px"
                    height="160px"
                  >
                    <Circle3
                      cx="80"
                      cy="80"
                      r="70"
                      stroke-linecap="round"
                      style={{
                        strokeDashoffset:
                          campaignData.dataFailed.percentageVol,
                      }}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Tooltip 
        id="my-tooltip" 
        style={{ zIndex: 9999, backgroundColor: "black", color: "white", padding: "5px 10px", borderRadius: "5px", whiteSpace: "pre-line", maxWidth: "500px" }} 
      />

      <Toaster />
      
      {/* <ToastContainer 
        position="top-center"
        autoClose={52000}
        // autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        // draggable
        theme={JSON.parse(localStorage.getItem("THEME")) ? "dark" : "light"}
        toastClassName="custom-toast" // Aplica estilos personalizados a cada toast individualmente
        bodyClassName="custom-toast-body"
      /> */}
    </Fragment>
  );
};

export default CampaignReport;


const Circle = styled.circle`
  fill: none;
  stroke-width: 20px;
  stroke-dasharray: 472;
  //  stroke-dashoffset: 0;
  stroke: #667580;
`;

const Circle1 = styled.circle`
  fill: none;
  stroke-width: 20px;
  stroke-dasharray: 472;
  //  stroke-dashoffset: 0;
  stroke: #58b658;
`;

const Circle2 = styled.circle`
  fill: none;
  stroke-width: 20px;
  stroke-dasharray: 472;
  stroke-dashoffset: 0;
  stroke: #57bedd;
`;

const Circle3 = styled.circle`
  fill: none;
  stroke-width: 20px;
  stroke-dasharray: 472;
  stroke-dashoffset: 0;
  stroke: #f81a33;
`;